import styled from 'styled-components';

export const ServicesStyled = styled.div`
  & .container {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
  }
`;

export const ServiceContainerStyled = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
`;

export const ServicesDetailsStyled = styled.div`
  padding: 0px 30px 80px;
  border-top: 1px solid ${({ theme }) => theme.colors.disable};
  display: flex;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const ServiceMenuContainerStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.blueShadow};
  padding: 20px;
  width: 100%;
  max-width: 300px;
  position: sticky;
  top: 65px;
  height: fit-content;
  max-height: 500px;
  @media (max-width: 800px) {
    position: relative;
    margin-bottom: 30px;
    max-width: 100%;
  }

  & .menu-item {
    font-size: 14px;
    line-height: 17px;
    font-weight: 500;
    cursor: pointer;

    margin-bottom: 14px;

    &.active {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const DetailsContainerStyled = styled.div`
  padding: 50px 80px;

  & .section {
    margin-bottom: 80px;
    & .section-title {
      font-size: 32px;
      line-height: 50px;
      font-weight: 600;
      margin-bottom: 30px;
    }
    & .color-text {
      &__primary {
        color: ${({ theme }) => theme.colors.primary};
      }
      &__sky-blue {
        color: ${({ theme }) => theme.colors.skyBlueLight};
      }
    }

    & .section-desc {
      font-size: 16px;
      line-height: 27px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    & .list-desc {
      font-size: 14px;
      line-height: 25px;
      font-weight: 500;
      margin-bottom: 20px;
    }
  }

  & .list-container {
    background: ${({ theme }) => theme.colors.blueShadow};
    padding: 20px;
  }
  & .list {
    position: relative;
    padding-left: 60px;
    margin-bottom: 20px;

    & .numberBullet {
      position: absolute;
      left: 0px;
      top: 0px;
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;

      color: ${({ theme }) => theme.colors.white};
      background: ${({ theme }) => theme.colors.skyGreenLight};
      font-size: 16px;
      font-weight: 500;
    }
  }

  @media (max-width: 800px) {
    padding: 50px 30px;
  }

  @media (max-width: 500px) {
    padding: 50px 0px;
    & .section {
      margin-bottom: 80px;
      & .section-title {
        font-size: 18px;
        line-height: 32px;
      }
      & .section-desc {
        font-size: 14px;
        line-height: 25px;
      }
    }
  }
`;
